import React from 'react'
import MuiTypography from '@material-ui/core/Typography'
import { useStyles, getVariant } from 'styles/typography'
import { useTheme } from '@material-ui/core'

function Typography(
  {
    title = null,
    align = `left`,
    color = `letra`,
    variant = `Parrafo`,
    weight = `none`,
    size = 18,
    sizeMovile,
    minHeight = `auto`,
    backgroundColor = `none`,
    gutterBottom = false,
    textDecoration,
    className = ``,
    letterSpacing = `0px`,
    marginTopLink = 10,
    ...props
  },
  index,
) {
  const theme = useTheme()

  const classes = useStyles({
    ...theme,
    color,
    size,
    sizeMovile,
    weight,
    minHeight,
    backgroundColor,
    textDecoration,
    letterSpacing,
    marginTopLink,
  })
  const newVariant = getVariant(variant)

  return (
    <>
      <MuiTypography
        {...props}
        key={index}
        align={align}
        gutterBottom={gutterBottom}
        variant={newVariant}
        className={`${classes[variant]} ${className}`}
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
    </>
  )
}
export default Typography
